
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/check-booking",
      function () {
        return require("private-next-pages/check-booking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/check-booking"])
      });
    }
  